(function () {
  var KAUBOX_CSS = [
    '.kaubox-builder__progress-bar{display:flex;gap:.4rem;height:.9rem;background:transparent;overflow:visible;margin-bottom:.7rem;}',
    '.kaubox-builder__progress-seg{flex:1;border-radius:999px;background:rgba(42,82,57,.15);transition:background .25s ease,transform .25s ease;}',
    '.kaubox-builder__progress-seg.is-filled{background:#2a5239;}',
    '.kaubox-builder__summary-item{display:flex;align-items:center;justify-content:space-between;gap:.8rem;font-size:1.3rem;padding:.7rem 0;border-bottom:1px solid rgba(0,0,0,.06);}',
    '.kaubox-builder__summary-main{flex:1;min-width:0;}',
    '.kaubox-builder__summary-name{display:block;line-height:1.3;}',
    '.kaubox-builder__summary-tag{display:block;opacity:.7;font-size:1.15rem;margin-top:.15rem;white-space:normal;}',
    '.kaubox-builder__summary-ctrl{display:flex;align-items:center;gap:.35rem;flex-shrink:0;}',
    '.kaubox-builder__sum-btn{width:2.2rem;height:2.2rem;border-radius:50%;border:1.5px solid rgba(42,82,57,.3);background:transparent;color:#2a5239;font-size:1.4rem;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;}',
    '.kaubox-builder__sum-btn:hover{background:rgba(42,82,57,.08);border-color:#2a5239;}',
    '.kaubox-builder__sum-qty{min-width:1.4rem;text-align:center;font-size:1.3rem;font-weight:700;}',
    '.kaubox-builder__sum-remove{width:2.2rem;height:2.2rem;border:none;background:transparent;color:#b0392b;font-size:1.8rem;line-height:1;cursor:pointer;opacity:.55;display:flex;align-items:center;justify-content:center;padding:0;margin-left:.1rem;}',
    '.kaubox-builder__sum-remove:hover{opacity:1;}',
    '.kaubox-builder__card--sold{opacity:.45;filter:grayscale(1);pointer-events:none;position:relative;}',
    '.kaubox-builder__card--sold .kaubox-builder__card-name{text-decoration:line-through;text-decoration-thickness:1px;}',
    '.kaubox-builder__sold-badge{display:inline-flex;align-items:center;justify-content:center;white-space:nowrap;font-size:1.15rem;font-weight:700;letter-spacing:.02em;text-transform:uppercase;color:#6b6b6b;background:rgba(0,0,0,.07);border-radius:999px;padding:.45rem 1rem;}',
    '@media screen and (max-width:749px){.kaubox-builder__sum-btn,.kaubox-builder__sum-remove{width:2.6rem;height:2.6rem;}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('kaubox-builder-inline-css')) return;
    var style = document.createElement('style');
    style.id = 'kaubox-builder-inline-css';
    style.textContent = KAUBOX_CSS;
    document.head.appendChild(style);
  }

  function formatEUR(amount) {
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  function isSoldOut(item) {
    return item && item.available === false;
  }

  function collapseOnMobile(container) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var cards = Array.prototype.slice.call(container.children);
    var visibleCount = 6;
    if (cards.length <= visibleCount) return;
    var hidden = cards.slice(visibleCount);
    hidden.forEach(function (c) { c.hidden = true; });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kaubox-builder__more-btn';
    btn.textContent = 'Mehr anzeigen (+' + hidden.length + ')';
    btn.addEventListener('click', function () {
      hidden.forEach(function (c) { c.hidden = false; });
      btn.remove();
    });
    container.insertAdjacentElement('afterend', btn);
  }

  function init() {
    const root = document.querySelector('[data-kaubox-builder]');
    if (!root) return;

    injectCss();

    const catalogScript = document.querySelector('script[data-kaubox-catalog]');
    const catalog = JSON.parse(catalogScript.textContent);
    const catalogBySku = {};
    catalog.forEach((item) => (catalogBySku[item.sku] = item));

    const baseVariantId = parseInt(root.dataset.baseVariantId, 10);
    const basePrice = parseFloat(root.dataset.basePrice);
    const baseSlots = parseInt(root.dataset.baseSlots, 10);

    const normalContainer = root.querySelector('[data-group="normal"]');
    const premiumContainer = root.querySelector('[data-group="premium"]');
    const progressBarEl = root.querySelector('.kaubox-builder__progress-bar');
    const progressText = root.querySelector('[data-progress-text]');
    const summaryList = root.querySelector('[data-summary-list]');
    const summaryEmpty = root.querySelector('[data-summary-empty]');
    const totalPriceEl = root.querySelector('[data-total-price]');
    const savingsEl = root.querySelector('[data-savings]');
    const savingsRetailEl = root.querySelector('[data-savings-retail]');
    const savingsPctEl = root.querySelector('[data-savings-pct]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const errorEl = root.querySelector('[data-error]');
    const successEl = root.querySelector('[data-success]');

    const progressSegs = [];
    if (progressBarEl) {
      progressBarEl.innerHTML = '';
      for (let i = 0; i < baseSlots; i++) {
        const seg = document.createElement('span');
        seg.className = 'kaubox-builder__progress-seg';
        progressBarEl.appendChild(seg);
        progressSegs.push(seg);
      }
    }

    let unitLog = [];

    function countsBySku() {
      const counts = {};
      unitLog.forEach((sku) => (counts[sku] = (counts[sku] || 0) + 1));
      return counts;
    }

    function addUnit(sku) {
      if (isSoldOut(catalogBySku[sku])) return;
      unitLog.push(sku);
      update();
    }

    function removeOneUnit(sku) {
      const idx = unitLog.lastIndexOf(sku);
      if (idx !== -1) unitLog.splice(idx, 1);
      update();
    }

    function removeAllUnits(sku) {
      unitLog = unitLog.filter((s) => s !== sku);
      update();
    }

    function renderCard(item) {
      const sold = isSoldOut(item);
      const card = document.createElement('div');
      card.className =
        'kaubox-builder__card' +
        (item.premium ? ' kaubox-builder__card--premium' : '') +
        (sold ? ' kaubox-builder__card--sold' : '');
      card.dataset.sku = item.sku;
      card.setAttribute('role', 'listitem');
      const catClass = 'kaubox-builder__card-cat--' + (item.cat || 'rind');

      const info =
        '<div class="kaubox-builder__card-info">' +
        '<span class="kaubox-builder__card-cat ' + catClass + '">' + (item.catLabel || '') + '</span>' +
        '<p class="kaubox-builder__card-name">' + item.name + '</p>' +
        '<p class="kaubox-builder__card-price">' + formatEUR(item.price) + (item.premium ? ' <span class="kaubox-builder__badge">Premium</span>' : '') + '</p>' +
        '</div>';

      if (sold) {
        card.setAttribute('aria-disabled', 'true');
        card.innerHTML = info + '<span class="kaubox-builder__sold-badge">Ausverkauft</span>';
        return card;
      }

      card.innerHTML =
        info +
        '<div class="kaubox-builder__stepper">' +
        '<button type="button" class="kaubox-builder__step-btn" data-action="minus" aria-label="Weniger ' + item.name + '">−</button>' +
        '<span class="kaubox-builder__qty" data-qty>0</span>' +
        '<button type="button" class="kaubox-builder__step-btn" data-action="plus" aria-label="Mehr ' + item.name + '">+</button>' +
        '</div>';

      card.querySelector('[data-action="plus"]').addEventListener('click', () => {
        card.hidden = false;
        addUnit(item.sku);
      });
      card.querySelector('[data-action="minus"]').addEventListener('click', () => {
        removeOneUnit(item.sku);
      });

      return card;
    }

    // Verfügbare Snacks zuerst, ausverkaufte ans Ende der jeweiligen Gruppe
    const catalogOrdered = catalog
      .map((item, i) => ({ item: item, i: i }))
      .sort((a, b) => {
        const soldDiff = (isSoldOut(a.item) ? 1 : 0) - (isSoldOut(b.item) ? 1 : 0);
        return soldDiff !== 0 ? soldDiff : a.i - b.i;
      })
      .map((x) => x.item);

    catalogOrdered.forEach((item) => {
      const card = renderCard(item);
      (item.premium ? premiumContainer : normalContainer).appendChild(card);
    });

    collapseOnMobile(normalContainer);
    collapseOnMobile(premiumContainer);

    function update() {
      unitLog = unitLog.filter((sku) => catalogBySku[sku] && !isSoldOut(catalogBySku[sku]));

      const counts = countsBySku();

      root.querySelectorAll('.kaubox-builder__card').forEach((card) => {
        const qtyEl = card.querySelector('[data-qty]');
        if (!qtyEl) return;
        const sku = card.dataset.sku;
        const qty = counts[sku] || 0;
        qtyEl.textContent = qty;
        card.classList.toggle('kaubox-builder__card--active', qty > 0);
      });

      const normalUnits = unitLog.filter((sku) => !catalogBySku[sku].premium);
      const premiumUnits = unitLog.filter((sku) => catalogBySku[sku].premium);

      const includedUnits = normalUnits.slice(0, baseSlots);
      const extraNormalUnits = normalUnits.slice(baseSlots);
      const chargedExtraUnits = extraNormalUnits.concat(premiumUnits);

      const usedSlots = includedUnits.length;
      progressSegs.forEach((seg, i) => {
        seg.classList.toggle('is-filled', i < usedSlots);
      });
      progressText.textContent = usedSlots + ' von ' + baseSlots + ' Basis-Plätzen genutzt';

      let total = basePrice;
      chargedExtraUnits.forEach((sku) => (total += catalogBySku[sku].price));
      totalPriceEl.textContent = formatEUR(total);

      let retailTotal = 0;
      unitLog.forEach((sku) => (retailTotal += catalogBySku[sku].retail));
      const savings = retailTotal - total;
      if (unitLog.length > 0 && savings > 0.05) {
        const pct = Math.round((savings / retailTotal) * 100);
        savingsEl.hidden = false;
        savingsRetailEl.textContent = 'statt ' + formatEUR(retailTotal);
        savingsPctEl.textContent = 'Du sparst ' + formatEUR(savings) + ' (' + pct + '%)';
      } else {
        savingsEl.hidden = true;
      }

      summaryList.querySelectorAll('.kaubox-builder__summary-item').forEach((el) => el.remove());
      const allCounts = countsBySku();
      const skusInOrder = Object.keys(allCounts);
      if (skusInOrder.length === 0) {
        summaryEmpty.hidden = false;
      } else {
        summaryEmpty.hidden = true;
        skusInOrder.forEach((sku) => {
          const item = catalogBySku[sku];
          const qty = allCounts[sku];
          const li = document.createElement('li');
          li.className = 'kaubox-builder__summary-item';
          const includedCount = includedUnits.filter((s) => s === sku).length;
          const extraCount = qty - includedCount;
          let tag = '';
          if (includedCount > 0 && extraCount > 0) {
            tag = includedCount + '× inkl. + ' + extraCount + '× ' + formatEUR(item.price);
          } else if (includedCount > 0) {
            tag = includedCount + '× inkl.';
          } else {
            tag = extraCount + '× ' + formatEUR(item.price);
          }
          li.innerHTML =
            '<div class="kaubox-builder__summary-main">' +
            '<span class="kaubox-builder__summary-name">' + item.name + '</span>' +
            '<span class="kaubox-builder__summary-tag">' + tag + '</span>' +
            '</div>' +
            '<div class="kaubox-builder__summary-ctrl">' +
            '<button type="button" class="kaubox-builder__sum-btn" data-sum="minus" aria-label="Weniger ' + item.name + '">−</button>' +
            '<span class="kaubox-builder__sum-qty">' + qty + '</span>' +
            '<button type="button" class="kaubox-builder__sum-btn" data-sum="plus" aria-label="Mehr ' + item.name + '">+</button>' +
            '<button type="button" class="kaubox-builder__sum-remove" data-sum="remove" aria-label="' + item.name + ' entfernen" title="Entfernen">×</button>' +
            '</div>';

          li.querySelector('[data-sum="minus"]').addEventListener('click', () => removeOneUnit(sku));
          li.querySelector('[data-sum="plus"]').addEventListener('click', () => addUnit(sku));
          li.querySelector('[data-sum="remove"]').addEventListener('click', () => removeAllUnits(sku));

          summaryList.appendChild(li);
        });
      }

      addBtn.disabled = unitLog.length === 0;
      errorEl.hidden = true;
      successEl.hidden = true;
    }

    async function addToCart() {
      if (unitLog.length === 0) return;
      addBtn.disabled = true;
      addBtn.classList.add('loading');
      errorEl.hidden = true;
      successEl.hidden = true;

      const normalUnits = unitLog.filter((sku) => !catalogBySku[sku].premium);
      const premiumUnits = unitLog.filter((sku) => catalogBySku[sku].premium);
      const includedUnits = normalUnits.slice(0, baseSlots);
      const extraNormalUnits = normalUnits.slice(baseSlots);
      const chargedExtraUnits = extraNormalUnits.concat(premiumUnits);

      const includedCounts = {};
      includedUnits.forEach((sku) => (includedCounts[sku] = (includedCounts[sku] || 0) + 1));

      const extraCounts = {};
      chargedExtraUnits.forEach((sku) => (extraCounts[sku] = (extraCounts[sku] || 0) + 1));

      const bundleId = 'kb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

      const baseProperties = { _kaubox_bundle_id: bundleId };
      Object.keys(includedCounts).forEach((sku, i) => {
        baseProperties['Basis-Auswahl ' + (i + 1)] = catalogBySku[sku].name + (includedCounts[sku] > 1 ? ' x' + includedCounts[sku] : '');
      });
      if (Object.keys(extraCounts).length > 0) {
        baseProperties['Zusätze'] = Object.keys(extraCounts)
          .map((sku) => catalogBySku[sku].name + ' x' + extraCounts[sku])
          .join(', ');
      }

      const items = [
        {
          id: baseVariantId,
          quantity: 1,
          properties: baseProperties,
        },
      ];

      Object.keys(extraCounts).forEach((sku) => {
        items.push({
          id: catalogBySku[sku].variantId,
          quantity: extraCounts[sku],
          properties: { _kaubox_zusatz_fuer: 'KAUBOX Individual', _kaubox_bundle_id: bundleId },
        });
      });

      const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      try {
        const body = {
          items: items,
        };
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          body.sections = cartEl.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        const response = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error((data.description || data.message || 'Fehler beim Hinzufügen zum Warenkorb'));
        }

        successEl.hidden = false;

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'kaubox-builder',
            cartData: data,
          });
        }

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(data);
        }

        unitLog = [];
        update();
      } catch (err) {
        errorEl.hidden = false;
        errorEl.textContent = err.message || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.';
      } finally {
        addBtn.classList.remove('loading');
        addBtn.disabled = unitLog.length === 0;
      }
    }

    addBtn.addEventListener('click', addToCart);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
